var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnVideo = function SvgIcnVideo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic24movie"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 160354",
    d: "M10.9651 8.82699L13.2011 10.2376C13.3021 10.3013 13.3947 10.3777 13.4937 10.4444C14.2338 10.9433 15.3333 10.4691 15.3333 9.57804V5.9426C15.3333 5.05156 14.2338 4.5773 13.4937 5.07621C13.3947 5.14295 13.3021 5.21936 13.2011 5.28306L10.9651 6.69365M4 4H8.9651C10.0697 4 10.9651 4.89543 10.9651 6V10C10.9651 11.1046 10.0697 12 8.9651 12H4C2.89543 12 2 11.1046 2 10V6C2 4.89543 2.89543 4 4 4Z",
    stroke: "white",
    strokeWidth: 1.2
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnVideo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_video.87333e0d.svg";
export { ForwardRef as ReactComponent };